import * as React from "react";
import { PlacesType } from "react-tooltip";

type AllProps = {
  className: string;
  title?: string;
  tooltip?: string;
  tooltipPlace?: string;
  // size?: string;
  // animate?: string;
}

function IconComponent(props: AllProps) {
  const { className, title, tooltip, tooltipPlace } = props;
  return (
    <i
      className={className}
      title={title}
      data-tooltip-id="pv-tooltip"
      data-tooltip-content={tooltip}
      data-tooltip-place={tooltipPlace as PlacesType}
    ></i>
  );
}

export default React.memo(IconComponent);

